/* unplugin-vue-components disabled */import { render } from "./MyClassRoomView.vue?vue&type=template&id=2dffecc2&scoped=true"
import script from "./MyClassRoomView.vue?vue&type=script&lang=js"
export * from "./MyClassRoomView.vue?vue&type=script&lang=js"

import "./MyClassRoomView.vue?vue&type=style&index=0&id=2dffecc2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dffecc2"]])

export default __exports__